// src/utils/legalVersions.js
// Single source of truth for Loop legal acceptance versions.
// Bump these values whenever Terms, Privacy or Payments policy materially change.

export const LOOP_LEGAL_TERMS_VERSION = "2026-06-payments-v2";
export const LOOP_LEGAL_PRIVACY_VERSION = "2026-06-payments-v2";
export const LOOP_LEGAL_PAYMENTS_VERSION = "2026-08-membership-subscriptions-v1";
export const LOOP_LEGAL_SNAPSHOT_VERSION = "2026-08-membership-subscriptions-v1";

export const LOOP_LEGAL_UPDATED_LABEL = "Agosto 2026";
export const LOOP_MEMBERSHIP_SUBSCRIPTION_TERMS_VERSION = "2026-08-membership-subscriptions-v1";
export const LOOP_MEMBERSHIP_CANCELLATION_POLICY_VERSION = "2026-08-membership-subscriptions-v1";
export const LOOP_SUPPORT_EMAIL = "soporte@loopreservas.com";

export function buildLoopLegalAcceptancePatch({ uid = "", email = "", source = "legal_update_modal", from = "app_session", platform = "web" } = {}) {
  const nowIso = new Date().toISOString();
  const cleanUid = String(uid || "").trim();
  const cleanEmail = String(email || "").trim().toLowerCase();
  return {
    legalAccepted: true,
    legalAcceptedAt: nowIso,
    legalAcceptedFrom: from,
    legalAcceptedSource: source,
    legalAcceptedByUid: cleanUid || null,
    legalAcceptedByEmail: cleanEmail || null,
    legalTermsVersion: LOOP_LEGAL_TERMS_VERSION,
    legalPrivacyVersion: LOOP_LEGAL_PRIVACY_VERSION,
    legalPaymentsVersion: LOOP_LEGAL_PAYMENTS_VERSION,
    legalSnapshotVersion: LOOP_LEGAL_SNAPSHOT_VERSION,
    legalUpdatedAt: nowIso,
    termsAccepted: true,
    acceptedTerms: true,
    termsAcceptedAt: nowIso,
    acceptedTermsAt: nowIso,
    privacyAccepted: true,
    privacyAcceptedAt: nowIso,
    paymentsPolicyAccepted: true,
    paymentsPolicyAcceptedAt: nowIso,
    minimumAgeConfirmed: true,
    legalAcceptanceMeta: { source, from, platform, termsVersion: LOOP_LEGAL_TERMS_VERSION, privacyVersion: LOOP_LEGAL_PRIVACY_VERSION, paymentsVersion: LOOP_LEGAL_PAYMENTS_VERSION, snapshotVersion: LOOP_LEGAL_SNAPSHOT_VERSION, acceptedAt: nowIso },
  };
}

export function hasAcceptedCurrentLoopLegal(userDoc = {}) {
  if (!userDoc || typeof userDoc !== "object") return false;
  return userDoc.legalAccepted === true && userDoc.legalTermsVersion === LOOP_LEGAL_TERMS_VERSION && userDoc.legalPrivacyVersion === LOOP_LEGAL_PRIVACY_VERSION && userDoc.legalPaymentsVersion === LOOP_LEGAL_PAYMENTS_VERSION;
}

export function loopLegalHistoryDocId(uid = "") {
  const safeUid = String(uid || "user").trim().replace(/[^a-zA-Z0-9_-]/g, "_").slice(0, 80) || "user";
  return `${safeUid}_${LOOP_LEGAL_TERMS_VERSION}_${LOOP_LEGAL_PRIVACY_VERSION}_${LOOP_LEGAL_PAYMENTS_VERSION}`.replace(/[^a-zA-Z0-9_-]/g, "_").slice(0, 420);
}
